import { useCallback, useEffect, useState } from 'react';
import { createStyles, Dialog, Divider, Grid, makeStyles, Paper, PaperProps, Theme, withStyles } from '@material-ui/core';
import { useDispatch, useSelector } from "react-redux";
import { getCreatorOnboarding, moveNextPage } from "../../../../store/actions/creator/creatorOnBoarding";
import { getUserProfile } from "../../../../store/actions";
import OnBoardingBackground from './background';
import { Helmet } from "react-helmet";
import OnBoardingStart from "./start";
import OnboardingTopbar from "./topbar";
import Module1Slide1 from "./module1/slide1";
import Module1Slide2 from "./module1/slide2";
import Module1Slide3 from "./module1/slide3";
import Module1Slide4 from "./module1/slide4";
import Module1Slide5 from "./module1/slide5";
import Module1Slide6 from "./module1/slide6";
import Module1Finish from "./module1/finish";
import MuiDialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Draggable from "react-draggable";
import Module2Slide1 from './module2/slide1';
import Module2Slide2 from './module2/slide2';
import Module2Slide3 from './module2/slide3';
import Module3Slide1 from "./module3/slide1";
import Module3Slide2 from "./module3/slide2";
import Module4Slide1 from "./module4/slide1";
import { Prompt } from 'react-router-dom';
import { useHistory } from "react-router";
import LeaveOnboardingModal from "../../../atoms/modals/leaveOnboardingModal";
import Module4Slide2 from './module4/slide2';
import Module4Finish from "./module4/finish";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      paddingTop: 26,
      backgroundColor: '#127AEF',
      cursor: 'move'
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      background: 'transparent!important'
    },
    header: {
      color: '#FFFFFF',
      fontFamily: 'Spartan-bold',
      fontSize: 30,
      paddingLeft: 17,
      paddingBottom: 7,
      display: 'flex',
      alignItems: 'center',
    }
  });

const PaperComponent = (props: PaperProps) => {
  const children = <Paper {...props} />
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
      {...{ children }}
    />
  );
};

const DialogTitle = withStyles(styles)((props: any) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className={classes.header}>
        {children}
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <img src={'/assets/icons/onboarding/checklist-close.svg'} alt={'Icon'} />
          </IconButton>
        ) : null}
      </div>
    </MuiDialogTitle>
  );
});

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  dialog: {

  },
  paper: {
    maxWidth: 600,
    borderRadius: '24px!important'
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    paddingLeft: 20,
    paddingRight: 20
  },
  stepTitle: {
    color: '#697683',
    fontFamily: 'roboto-regular',
    fontSize: 20,
    paddingLeft: 20
  },
  icon: {
    width: 23,
    height: 23,
    marginLeft: 30
  },
  stepDiv: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 80,
    borderBottom: '2px solid #D9D9D9'
  }
}));

function OnBoarding() {
  const classes = useStyles();
  const history = useHistory();
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};
  const { page, lastPreference, userPreferences, is_loaded } = useSelector((state: any) => state.creatorOnBoarding);
  const { activepage } = userPreferences;
  const [pageloaded, setPageloaded] = useState(false);
  const [showCheckList, setShowCheckList] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [leaveUrl, setLeaveUrl] = useState('');
  const [leaveOnboarding, setLeaveOnboarding] = useState(false);
  const dispatch = useDispatch();
  const apolloClient = useSelector((state: any) => state.apolloClient);

  // useEffect(() => {
  //   window.onpopstate = () => {
  //     const hash = history.location.hash;
  //     switch (hash) {
  //       case '#welcome':
  //         dispatch(moveNextPage(0));
  //         return;
  //       case '#about':
  //         dispatch(moveNextPage(1));
  //         return;
  //       case '#question1':
  //         dispatch(movePickFlag(false));
  //         dispatch(moveNextPage(2));
  //         return;
  //       case '#question2':
  //         dispatch(movePickFlag(true));
  //         dispatch(moveNextPage(2));
  //         return;
  //       case '#question3':
  //       case '#itty':
  //         dispatch(moveNextPage(3));
  //         return;
  //       case '#question4':
  //         dispatch(moveNextPage(4));
  //         return;
  //       case '#intro':
  //         dispatch(moveNextPage(5));
  //         return;
  //       case '#onboard':
  //         dispatch(moveNextPage(6));
  //         return;
  //     }
  //   }
  // }, [window, history.location.hash]);

  useEffect(() => {
    dispatch(getUserProfile(apolloClient.client, { user_id: loginUserData.user_id }))
  }, [apolloClient.client, loginUserData.user_id, dispatch]);

  useEffect(() => {
    dispatch(getCreatorOnboarding(apolloClient.client, { user_id: loginUserData.user_id }))
  }, [lastPreference, apolloClient.client, loginUserData.user_id, dispatch]);

  useEffect(() => {
    if (is_loaded && !pageloaded) {
      goLastStep();
      setPageloaded(true)
    }
  }, [is_loaded]);

  useEffect(() => {
    if (leaveOnboarding) {
      history.push(leaveUrl);
    }
  }, [leaveOnboarding]);

  const goLastStep = () => {
    dispatch(moveNextPage(Number(activepage.value)));
  };

  const isTrial = useCallback(() => {
    if (!!loginUserData) {
      return (loginUserData.department_id ? true : false);
    }
    return false;
  }, [loginUserData]);

  const isTeamOwner = useCallback(() => {
    if (!!loginUserData) {
      return (loginUserData.department_id && !loginUserData.department_alias ? true : false);
    }
    return false;
  }, [loginUserData]);

  const onShowCheckList = () => {
    setShowCheckList(true);
  };

  const onCloseCheckList = () => {
    setShowCheckList(false);
  };

  const onLeavePage = (e: any) => {
    const url = e.pathname;
    if (url.includes('/creator/experience-builder') || url.includes('/creator/dashboard')) {
      setLeaveOnboarding(true);
      return true;
    }
    if (url === '/creator/onboarding' || url === '/subscriber/creator/onboarding') {
      return true;
    } else {
      if (leaveOnboarding) {
        return true;
      } else {
        setLeaveUrl(url);
        setShowConfirmModal(true);
        return false;
      }
    }
  };

  const handleClose = () => {
    setShowConfirmModal(false);
  };

  const goSelectedPage = () => {
    setLeaveOnboarding(true);
  };

  const checkMark = useCallback((page: any) => {
    return Number(activepage.value) >= page;
  }, [activepage]);

  return (
    <div className={classes.root}>
      <Helmet title="Creator Onboarding" />
      {page > 1 && <OnboardingTopbar onShowPopup={onShowCheckList} />}
      <Grid container justifyContent={'center'} className={classes.container}>
        {page === 0 && <Grid item lg={8} md={12} sm={12}><OnBoardingBackground isTrial={isTrial()} isTeamOwner={isTeamOwner()} loginUserData={loginUserData} /></Grid>}
        {page === 1 && <Grid item lg={8} md={10} sm={12}><OnBoardingStart /></Grid>}

        {page === 2 && <Grid item lg={10} md={10} sm={12}><Module1Slide1 /></Grid>}
        {page === 3 && <Grid item lg={11} md={11} sm={12}><Module1Slide2 /></Grid>}
        {page === 4 && <Grid item lg={10} md={10} sm={12}><Module1Slide3 /></Grid>}
        {page === 5 && <Grid item lg={10} md={10} sm={12}><Module1Slide4 /></Grid>}
        {page === 6 && <Grid item lg={8} md={12} sm={12}><Module1Slide5 /></Grid>}
        {page === 7 && <Grid item lg={8} md={12} sm={12}><Module1Slide6 /></Grid>}
        {page === 8 && <Grid item lg={8} md={10} sm={12}><Module1Finish /></Grid>}

        {page === 9 && <Grid item lg={8} md={10} sm={12}><Module2Slide1 /></Grid>}
        {page === 10 && <Grid item lg={8} md={10} sm={12}><Module2Slide2 /></Grid>}
        {page === 11 && <Grid item lg={8} md={10} sm={12}><Module2Slide3 /></Grid>}

        {page === 12 && <Grid item lg={12} md={12} sm={12}><Module3Slide1 /></Grid>}
        {page === 13 && <Grid item lg={10} md={10} sm={12}><Module3Slide2 /></Grid>}

        {page === 14 && <Grid item lg={10} md={12} sm={12}><Module4Slide1 /></Grid>}
        {page === 15 && <Module4Slide2 />}
        {page === 16 && <Grid item lg={10} md={10} sm={12}><Module4Finish /></Grid>}

      </Grid>

      <Dialog
        disableEscapeKeyDown
        fullWidth={true}
        maxWidth={'sm'}
        scroll='paper'
        open={showCheckList}
        classes={{
          root: classes.dialog,
          paper: classes.paper
        }}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle onClose={() => onCloseCheckList()} id="draggable-dialog-title">
          Onboarding Checklist
        </DialogTitle>
        <Divider />
        <div>
          <div className={classes.stepDiv}>
            {checkMark(9) ? (
              <img className={classes.icon} src={'/assets/icons/onboarding/popup-check.svg'} alt={'Check'} />
            ) : (
              <img className={classes.icon} src={'/assets/icons/onboarding/popup-uncheck.svg'} alt={'Uncheck'} />
            )}
            <div className={classes.stepTitle}>LEARN HOW IT WORKS</div>
          </div>
          <div className={classes.stepDiv}>
            {checkMark(12) ? (
              <img className={classes.icon} src={'/assets/icons/onboarding/popup-check.svg'} alt={'Check'} />
            ) : (
              <img className={classes.icon} src={'/assets/icons/onboarding/popup-uncheck.svg'} alt={'Uncheck'} />
            )}
            <div className={classes.stepTitle}>MEASURE A VIDEO</div>
          </div>
          <div className={classes.stepDiv}>
            {checkMark(14) ? (
              <img className={classes.icon} src={'/assets/icons/onboarding/popup-check.svg'} alt={'Check'} />
            ) : (
              <img className={classes.icon} src={'/assets/icons/onboarding/popup-uncheck.svg'} alt={'Uncheck'} />
            )}
            <div className={classes.stepTitle}>SCHEDULE A CONSULT</div>
          </div>
          <div className={classes.stepDiv} style={{ borderBottom: 'unset' }}>
            {checkMark(16) ? (
              <img className={classes.icon} src={'/assets/icons/onboarding/popup-check.svg'} alt={'Check'} />
            ) : (
              <img className={classes.icon} src={'/assets/icons/onboarding/popup-uncheck.svg'} alt={'Uncheck'} />
            )}
            <div className={classes.stepTitle}>ANALYZE SOME RESULTS</div>
          </div>
        </div>
      </Dialog>

      <LeaveOnboardingModal
        open={showConfirmModal}
        onClose={handleClose}
        onApply={goSelectedPage}
      />

      <Prompt
        message={onLeavePage}
      />

    </div>
  )
}

export default OnBoarding;